export class TableFieldParameter {
  head: string[] | undefined;
  min: number | undefined;
  max: number | undefined;
  sum: boolean | undefined;
}
